const prod = process.env.REACT_APP_API_URL;
const dev = process.env.REACT_APP_API_URL_DEV;

export const API_URL = process.env.NODE_ENV === "development" ? dev : prod;

export const PROJECT_URL = process.env.REACT_APP_PROJECT_URL;

export const FUNCTION_API_URL = process.env.REACT_APP_FUNCTION_API_URL || "http://localhost:7071/api/authorizer";

// export const ONBOARD_URL = process.env.REACT_APP_ONBOARD_CLIENT_URL;
export const FUNCTION_BASE_URL = process.env.REACT_APP_FUNCTION_BASE_URL;
export const FUNCTION_CODE = process.env.REACT_APP_FUNCTION_CODE;

export const UPLOAD_URL = process.env.REACT_APP_UPLOAD_URL;
export const TRANSCRIPT_URL = process.env.REACT_APP_TRANSCRIPT_URL;

export const GETIDEAS_URL = process.env.REACT_APP_GETIDEAS_URL;
export const RAWANSWERS_URL = process.env.REACT_APP_RAWANSWERS_URL;
export const REFINEDANSWER_URL = process.env.REACT_APP_REFINEDANSWER_URL;
export const QUESTIONDB_URL = process.env.REACT_APP_QUESTIONDB_URL;
export const POSTPROCESSING_URL = process.env.REACT_APP_POSTPROCESSING_URL;
